import { render, staticRenderFns } from "./SocialEdit.vue?vue&type=template&id=d1587732"
import script from "./SocialEdit.vue?vue&type=script&lang=js"
export * from "./SocialEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports